'use client';

import { useFormContext } from 'react-hook-form';
import type {
  ReservationFormInputValues,
  ReservationFormValues,
} from '@eliadmin/core/src/components/reservation/reservation-form/reservation-form-schema';
import { Field } from '@eliadmin/core/src/components/form/field';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function ReservationFormStep3() {
  const { t } = useTranslations();
  const form = useFormContext<ReservationFormInputValues, any, ReservationFormValues>();

  return (
    <div className="grid w-full grid-cols-12 gap-4">
      <Field
        required
        name="name"
        label="Meno *"
        placeholder={t('text1044')}
        control={form.control}
        className={{ wrapper: 'col-span-12 w-full sm:col-span-6' }}
      />
      <Field
        required
        name="surname"
        label="Priezvisko *"
        placeholder="Vaše priezvisko"
        control={form.control}
        className={{ wrapper: 'col-span-12 w-full sm:col-span-6' }}
      />
      <Field
        required
        name="email"
        type="email"
        label="E-mail *"
        placeholder="Vaša e-mailová adresa"
        control={form.control}
        className={{ wrapper: 'col-span-12 w-full sm:col-span-6' }}
      />
      <Field
        name="phone"
        label={t('text1258')}
        placeholder="Vaše telefónne číslo +421..."
        control={form.control}
        className={{ wrapper: 'col-span-12 w-full sm:col-span-6' }}
      />
      <Field
        name="note"
        label="Poznámka pre nás"
        placeholder="Napr. Máme so sebou bicykle, kde ich môžeme uložiť ?"
        type="textarea"
        control={form.control}
        className={{ wrapper: 'col-span-12 w-full' }}
      />
    </div>
  );
}
